export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 145,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('form_label_picture') || '图片',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' }
  },
  {
    title: that.$l('table_label_material_no') || '物料编号',
    field: 'materialNo',
    minWidth: 150,
    align: 'left',
    fixed: 'left',
  },
  {
    title: that.$l('INDEX.table_label_State') || '状态',
    width: 80,
    align: 'center',
    slots: { default: 'status' }
  },
  {
    title: that.$l('table_label_materialCategory') || '物料分类',
    field: 'materialCategory',
    minWidth: 150,
    align: 'left',
    slots: { default: 'materialCategory' }
  },
  {
    title: that.$l('table_label_materialName') || '中文名称',
    field: 'materialName',
    minWidth: 200,
    align: 'left'
  },
  {
    title: that.$l('table_label_materialNameEn') || '英文名称',
    field: 'materialNameEn',
    minWidth: 200,
    align: 'left'
  },
  {
    title: that.$l('table_label_materialDesc') || '材质',
    field: 'materialDesc',
    minWidth: 200,
    align: 'left'
  },
  {
    title: that.$l('table_label_materialSpec') || '尺寸规格',
    field: 'materialSpec',
    minWidth: 200,
    align: 'left'
  },
  {
    title: that.$l('table_label_custName') || '所属客户',
    field: 'custName',
    minWidth: 250,
    align: 'left'
  },
  {
    title: that.$l('table_label_brandName') || '所属品牌',
    field: 'brandName',
    minWidth: 100,
    align: 'left'
  },
  {
    title: that.$l('table_label_customerMaterialNo') || '客户物料编号',
    field: 'customerMaterialNo',
    minWidth: 100,
    align: 'left'
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    title: that.$l('INDEX.creator') || '创建人',
    slots: { default: 'displayCreateByName' }
  }
]
